import { Box, ButtonBase } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { useCustomColors } from "../../hooks/useCustomColors";

const LanguageSwitcher = () => {
  const colors = useCustomColors();
  const { palette } = useTheme();
  const isDark = palette.mode === "dark";
  const { i18n } = useTranslation();
  const activeLanguage = i18n.language.startsWith("zh") ? "zh" : "en";

  return (
    <Box
      sx={{
        width: "100%",
        p: "3px",
        display: "flex",
        gap: "3px",
        borderRadius: "13px",
        backgroundColor: colors.background.rail,
        border: `1px solid ${colors.border.accent}`,
      }}
    >
      {[{ code: "en", label: "English" }, { code: "zh", label: "中文" }].map((language) => {
        const isActive = activeLanguage === language.code;
        return (
          <ButtonBase
            key={language.code}
            onClick={() => i18n.changeLanguage(language.code)}
            sx={{
              flex: 1,
              minHeight: "30px",
              px: "8px",
              borderRadius: "10px",
              color: isActive ? "#FFFFFF" : colors.text.secondary,
              background: isActive ? colors.gradient.brand : "transparent",
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: "0.2px",
              transition: "all 150ms ease",
              "&:hover": {
                color: isActive ? "#FFFFFF" : isDark ? "#FFFFFF" : colors.text.primary,
                backgroundColor: isActive ? undefined : colors.background.panelSecondary,
              },
            }}
          >
            {language.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default LanguageSwitcher;
